<template>
  <v-dialog
    overlay-color="black"
    overlay-opacity="0.7"
    persistent
    max-width="420"
    v-model="show"
  >
    <v-card :dark="darkMode" class="connection-lost-card">
      <v-card-text class="pt-6 pb-2 text-center">
        <v-icon size="64" :color="iconColor" class="mb-4">
          {{ reconnecting ? "mdi-loading mdi-spin" : "mdi-lan-disconnect" }}
        </v-icon>
        <div class="text-h6 mb-2" :class="textClass">Connection lost</div>
        <div class="body-2" :class="subtextClass">
          The real-time connection to the server was interrupted. Some features
          like downloads and uploads won't work until the connection is restored.
        </div>
        <v-expand-transition>
          <div
            v-if="attempts > 0 && !reconnecting"
            class="caption mt-2"
            :class="subtextClass"
          >
            Reconnection failed ({{ attempts }}
            {{ attempts === 1 ? "attempt" : "attempts" }}).
          </div>
        </v-expand-transition>
      </v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn
          class="connection-lost-btn connection-lost-btn--primary"
          color="primary"
          :loading="reconnecting"
          :disabled="reconnecting"
          @click="$emit('reconnect')"
          depressed
        >
          <v-icon left small>mdi-refresh</v-icon>
          Reconnect
        </v-btn>
        <v-btn
          :dark="darkMode"
          class="connection-lost-btn connection-lost-btn--secondary"
          text
          @click="dismiss"
        >
          Dismiss
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ConnectionLostDialog",
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: { type: Boolean, required: true },
    reconnecting: { type: Boolean, default: false },
    attempts: { type: Number, default: 0 }
  },
  computed: {
    ...mapGetters(["darkMode"]),
    iconColor() {
      return this.reconnecting ? "primary" : "warning";
    },
    textClass() {
      return this.darkMode ? "white--text" : "grey--text text--darken-3";
    },
    subtextClass() {
      return this.darkMode
        ? "grey--text text--lighten-1"
        : "grey--text text--darken-1";
    }
  },
  methods: {
    dismiss() {
      this.$emit("update:show", false);
    }
  }
};
</script>

<style scoped>
.connection-lost-card {
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.26);
}

.connection-lost-btn {
  border-radius: 12px !important;
  text-transform: none;
  letter-spacing: 0.01em;
  min-width: 110px;
}

.connection-lost-btn--primary {
  box-shadow: 0 10px 24px rgba(67, 149, 163, 0.24);
}

.connection-lost-btn--secondary {
  min-width: 90px;
}
</style>
